import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { ReportsPaymentsAndRefundsFilterPage } from 'src/app/modals/reports-payments-and-refunds-filter/reports-payments-and-refunds-filter.page';

const routes: Routes = [
  {
    path: '',
    component: ReportsPaymentsAndRefundsFilterPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ReportsPaymentsAndRefundsFilterPage]
})
export class ReportsPaymentsAndRefundsFilterPageModule {}
